cv.DonationsRowView = Marionette.LayoutView.extend({
  className : 'donation',
  template: cv.Templates['donations/row'],

  events : {
  },

  templateHelpers: function(){
    return {
      name : this.model.get('first_name') + ' ' + this.model.get('last_name'),
      is_anonymous : this.model.get('anonymous') == 1 ? true : false,
      amount : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('amount'),
        currency_code : this.model.get('campaign.currency_code'),
        decimal_places : 2
      }),
      email : this.model.get('email'),
      has_comment : this.model.get('comment') == '' ? false : true,
      comment : this.model.get('comment'),
      created_at_date : moment(this.model.get('created_at') + 'Z').tz(this.model.get('campaign.timezone')).format('MMM D'),
      created_at_time : moment(this.model.get('created_at') + 'Z').tz(this.model.get('campaign.timezone')).format('h:mm A')
    };
  },

  initialize: function(options){
    console.log('DonationsRowView initialized');
  },

  onAttach: function(){
    imgix.fluid(this.$el.get(0), {
      rootNode: this.$el.get(0),
      updateOnResizeDown: false,
      autoInsertCSSBestPractices: true
    });

    this.$el.attr('href', '/team/' + this.model.get('stub'))
  }
});
